import script from "./Previewer.vue?vue&type=script&setup=true&lang=js"
export * from "./Previewer.vue?vue&type=script&setup=true&lang=js"

import "./Previewer.vue?vue&type=style&index=0&id=d50bffac&scoped=true&lang=postcss"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d50bffac"]])

export default __exports__